<main class="{{ tablet ? 'tablet' : mobile ? 'mobile' : '' }}">
  @if (settingsModel()) {
    <app-menu></app-menu>
  }
  <router-outlet></router-outlet>
  @if (settingsModel()) {
    <app-footer></app-footer>
  }
</main>
@if (cookieConsentShow() && hasScrolled) {
  <div
    id="cookie-consent-wrapper"
    itemscope
    itemtype="https://schema.org/CookieConsent"
  >
    <div class="cookie-consent">
      <div>
        <div class="text">
          <h2>Vi bruker informasjonskapsler</h2>
          <p>
            Vi vil gjerne gi deg den beste opplevelsen når du besøker nettstedet
            vårt. Derfor bruker vi informasjonskapsler (cookies) til følgende:
          </p>
          <ol>
            <li>
              Å sikre at alt <strong>fungerer</strong> som det skal
              (funksjonelle cookies)
            </li>
            <li>
              Å forstå hva som er <strong>populært</strong>, og hvordan vi kan
              gjøre siden bedre (statistikk)
            </li>
            <li>
              Å vise deg <strong>relevante</strong> tilbud og innhold
              (markedsføring)
            </li>
          </ol>
          <p>
            Klikk <strong>"OK"</strong> for å gi samtykke til alle, eller velg
            selv hvilke du ønsker å tillate. Bruk avkrysningsboksene for å velge
            og klikk "<strong>Lagre innstillinger</strong>".
          </p>
          <p>
            Du kan når som helst endre eller trekke tilbake samtykket ditt ved å
            klikke på ikonet nederst til venstre på sidan.
          </p>
          <p>
            Les mer om hvordan vi beskytter dine data i vår
            <a href="/personvernpolitikk">Personvernerklæring</a> og
            <a href="/cookies">Retningslinjer</a> for informasjonskapsler. Vi
            følger Googles retningslinjer for åpenhet og kontroll over dine
            data.
          </p>
          <div class="bottom-blur"></div>
        </div>
        <div class="expansion-panel">
          <div class="expansion-panel-header" (click)="toggleExpansionPanel()">
            <div>Mer info om cookies</div>
            <div class="expansion-icon">
              {{ isExpansionPanelOpen ? "−" : "+" }}
            </div>
          </div>
          @if (isExpansionPanelOpen) {
            <div class="expansion-panel-body">
              <p>Her er en komplett liste over alle våre cookies:</p>
              <figure class="table">
                <table>
                  <tbody>
                    <tr>
                      <td>Service:</td>
                      <td>Event.no.no</td>
                    </tr>
                    <tr>
                      <td>Syfte:</td>
                      <td>
                        Cookies brukes til å se om du allerede har sett og
                        godkjent bruken av cookies
                      </td>
                    </tr>
                    <tr>
                      <td>Navn:</td>
                      <td>cookie-consent</td>
                    </tr>
                    <tr>
                      <td>Expiry:</td>
                      <td>
                        1 år, eller til vi oppdaterer cookie-informasjonen
                      </td>
                    </tr>
                  </tbody>
                </table>
              </figure>
              <figure class="table">
                <table>
                  <tbody>
                    <tr>
                      <td>Service:</td>
                      <td>Google Tag Manager</td>
                    </tr>
                    <tr>
                      <td>Syfte:</td>
                      <td>
                        Disse informasjonskapslene, levert av Google Inc.,
                        brukes til å samle inn informasjon om hvordan besøkende
                        bruker nettstedet vårt. Vi bruker informasjonen til å
                        kompliere rapporter og hjelpe oss med å forbedre
                        nettstedet. Informasjonskapslene samler inn informasjon
                        i en anonym form, inkludert antall besøkende på
                        nettstedet, der besøkende har besøkt nettstedet fra og
                        sidene de besøkte.
                      </td>
                    </tr>
                    <tr>
                      <td>Navn:</td>
                      <td>_ga*</td>
                    </tr>
                    <tr>
                      <td>Expiry:</td>
                      <td>
                        2 år, eller til vi oppdaterer cookie-informasjonen
                      </td>
                    </tr>
                    <tr>
                      <td>Privacy policy:</td>
                      <td>
                        Cookies brukes til å se om du allerede har sett og
                        godkjent bruken av cookies, hvis vi ønsker å endre
                        hvordan vi bruker cookies vil meldingen vises igjen for
                        ny godkjenning
                      </td>
                    </tr>
                  </tbody>
                </table>
              </figure>
            </div>
          }
        </div>

        <div class="buttons">
          @if (
            consent.Version > 0 ||
            consent.Analytics ||
            consent.Functional ||
            consent.Marketing
          ) {
            <button class="btn" color="primary" (click)="setAllCookies(false)">
              Oppdater
            </button>
          } @else {
            <button class="btn" (click)="declineAllCookies()">
              Avvis alle
            </button>
          }
          <button class="btn" (click)="setAllCookies(true)">Ok</button>
        </div>
        <div class="selectors">
          <div class="selector">
            <div class="selector-label">Funksjonelle</div>
            <label class="toggle-switch">
              <input
                type="checkbox"
                [(ngModel)]="consent.Functional"
                class="toggle-input"
              />
              <span class="toggle-slider"></span>
            </label>
          </div>
          <div class="selector">
            <div class="selector-label">Statistikk</div>
            <label class="toggle-switch">
              <input
                type="checkbox"
                [(ngModel)]="consent.Analytics"
                class="toggle-input"
              />
              <span class="toggle-slider"></span>
            </label>
          </div>
          <div class="selector">
            <div class="selector-label">Markedsføring</div>
            <label class="toggle-switch">
              <input
                type="checkbox"
                [(ngModel)]="consent.Marketing"
                class="toggle-input"
              />
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
}
